const initDetailCountySelect = () => {
    document.querySelectorAll("[data-detail-county-select]").forEach((select) => {
        select.addEventListener("change", () => {
            if (select.value) window.location.href = select.value;
        });
    });
};

const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (e) {}
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
        ok = document.execCommand("copy");
    } catch (e) {}
    document.body.removeChild(ta);
    return ok;
};

const initDetailShare = () => {
    document.querySelectorAll(".detail-share").forEach((btn) => {
        const label = btn.querySelector("span");
        btn.addEventListener("click", async () => {
            const url = window.location.href;
            if (navigator.share) {
                try {
                    await navigator.share({ title: document.title, url });
                    return;
                } catch (e) {
                    if (e && e.name === "AbortError") return;
                }
            }
            const copied = await copyToClipboard(url);
            if (!copied || !label || btn.classList.contains("is-copied")) return;
            const original = label.textContent;
            label.textContent = "Link Copied";
            btn.classList.add("is-copied");
            setTimeout(() => {
                label.textContent = original;
                btn.classList.remove("is-copied");
            }, 2000);
        });
    });
};

const initDetailNav = () => {
    const nav = document.querySelector(".detail-nav");
    if (!nav) return;
    const mainNav = document.querySelector(".main-nav");
    const applyOffset = () => {
        const mainH = mainNav ? mainNav.offsetHeight : 0;
        nav.style.top = mainH + "px";
        document.documentElement.style.scrollPaddingTop = mainH + nav.offsetHeight + "px";
    };
    applyOffset();
    window.addEventListener("resize", applyOffset, { passive: true });
    const links = Array.from(nav.querySelectorAll(".detail-nav-links a"));
    const select = nav.querySelector("[data-detail-nav-select]");
    if (select) {
        select.addEventListener("change", () => {
            const el = document.querySelector(select.value);
            if (el) el.scrollIntoView({ behavior: "smooth" });
        });
    }
    const targets = links.map((a) => document.querySelector(a.getAttribute("href"))).filter(Boolean);
    if (!targets.length || !("IntersectionObserver" in window)) return;
    const setActive = (id) => {
        links.forEach((a) => a.classList.toggle("active", a.getAttribute("href") === "#" + id));
        if (select && select.value !== "#" + id) select.value = "#" + id;
    };
    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) setActive(entry.target.id);
        });
    }, { rootMargin: "-40% 0px -55% 0px" });
    targets.forEach((t) => io.observe(t));
};

const initDetailElevations = () => {
    if (!window.Swiper) return;
    const el = document.querySelector(".detail-elevation-swiper");
    if (!el) return;
    const count = el.querySelectorAll(".swiper-slide").length;
    if (count < 2) return;
    const desktopPerView = count > 4 ? 3.15 : count;
    new window.Swiper(el, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
            768: { slidesPerView: desktopPerView, spaceBetween: 20 },
        },
        navigation: {
            prevEl: ".detail-elevation-prev",
            nextEl: ".detail-elevation-next",
        },
        pagination: {
            el: ".detail-elevation-count",
            type: "fraction",
            formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
            formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
        },
    });
};

const initDetailVideos = () => {
    if (!window.Swiper) return;
    const el = document.querySelector(".detail-video-swiper");
    if (!el) return;
    new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 24,
        watchOverflow: true,
        breakpoints: {
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
        },
        navigation: {
            prevEl: ".detail-video-prev",
            nextEl: ".detail-video-next",
        },
        pagination: {
            el: ".detail-video-count",
            type: "fraction",
            formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
            formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
        },
    });
};

const initDetailBlog = () => {
    if (!window.Swiper) return;
    const el = document.querySelector(".detail-blog-swiper");
    if (!el) return;
    new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 24,
        watchOverflow: true,
        breakpoints: {
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
        },
        navigation: {
            prevEl: ".detail-blog-prev",
            nextEl: ".detail-blog-next",
        },
        pagination: {
            el: ".detail-blog-count",
            type: "fraction",
            formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
            formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
        },
    });
};

const initDetailSimilar = () => {
    if (!window.Swiper) return;
    const el = document.querySelector(".detail-similar-swiper");
    if (!el) return;
    new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 40,
        watchOverflow: true,
        breakpoints: {
            768: { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.8, spaceBetween: 24 },
            1200: { slidesPerView: 3.5, spaceBetween: 24 },
        },
        navigation: {
            prevEl: ".detail-similar-prev",
            nextEl: ".detail-similar-next",
        },
        pagination: {
            el: ".detail-similar-count",
            type: "fraction",
            formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
            formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
        },
    });
};

const initDetailHomes = () => {
    if (!window.Swiper) return;
    const el = document.querySelector(".detail-homes-swiper");
    if (!el) return;
    new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 40,
        watchOverflow: true,
        breakpoints: {
            768: { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.8, spaceBetween: 24 },
            1200: { slidesPerView: 3.5, spaceBetween: 24 },
        },
        navigation: {
            prevEl: ".detail-homes-prev",
            nextEl: ".detail-homes-next",
        },
        pagination: {
            el: ".detail-homes-count",
            type: "fraction",
            formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
            formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
        },
    });
};

initDetailCountySelect();
initDetailShare();
initDetailNav();
initDetailElevations();
initDetailVideos();
initDetailBlog();
initDetailSimilar();
initDetailHomes();
